import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import AuthPage from './pages/AuthPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import AcceptInvitePage from './pages/AcceptInvitePage'
import VendorSignUpPage from './pages/VendorSignUpPage'
import DashboardPage from './pages/DashboardPage'
import VendorDashboardPage from './pages/VendorDashboardPage'
import AdminDashboardPage from './pages/AdminDashboardPage'
import ProtectedRoute from './components/ProtectedRoute'
import { useSessionRefresh } from './hooks/useSessionRefresh'

function App() {
  useSessionRefresh()
  return (
    <Routes>
      {/* Auth routes -- no sidebar/layout */}
      <Route path="/" element={<Navigate to="/auth" replace />} />
      <Route path="auth" element={<AuthPage />} />
      <Route path="auth/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="accept-invite" element={<AcceptInvitePage />} />
      <Route path="auth/signup" element={<VendorSignUpPage />} />

      {/* Authenticated routes -- with sidebar layout */}
      <Route path="/" element={<Layout />}>
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        {/* /vendor/onboarding removed -- onboarding is now inline on the Home page */}
        <Route
          path="vendor/onboarding"
          element={<Navigate to="/vendor" replace />}
        />
        <Route
          path="vendor/*"
          element={
            <ProtectedRoute roles={['vendor', 'vendor_admin']}>
              <VendorDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin/*"
          element={
            <ProtectedRoute roles={['SUPER_ADMIN', 'ADMIN', 'MODERATOR', 'VIEWER']}>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  )
}

export default App

